window.theme = window.theme || {};
var THMHelper = window.BEYHelper || {};
THMHelper.qs = document.querySelector.bind(document);
THMHelper.qsa = document.querySelectorAll.bind(document);
THMHelper.qid = document.getElementById.bind(document);
THMHelper.qde = document.documentElement;

var Thm = {
  init: function () {
    this.Basic.init();
  },
  Basic: {
    init: function () {
      this.smoothScroll();
      this.marqueeScroller();
      this.sticky_header();
      this.slideshowSwiper();
      this.autoSlider();
      this.videLoad();
      this.collapsibleContent();
    },
    sticky_header: function () {
      var header = document.querySelector('[data-sticky-type="always"]');

      if (header != null) {
        onScroll = () => {
          var scrolledPage = Math.round(window.pageYOffset);
          if (scrolledPage > 80) {
            header.classList.add('sticky');
          } else {
            header.classList.remove('sticky');
          }
        }
        document.addEventListener('scroll', onScroll);
      }
    },
    smoothScroll: function () {
      document.querySelectorAll('a[href*="#"]:not([href="#"]):not([href="#0"]):not([href="#recover"]):not([href="#login"])').forEach(a => {
        a.addEventListener('click', function (e) {
          if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
            var target = document.querySelector(this.hash) || document.querySelector('[name=' + this.hash.slice(1) + ']');
            if (target) {
              e.preventDefault();
              window.scrollTo({ top: target.offsetTop, behavior: 'smooth' });
              setTimeout(() => {
                target.focus();
                if (!target.matches(':focus')) {
                  target.setAttribute('tabindex', '-1');
                  target.focus();
                }
              }, 600);
            }
          }
        });
      });

    },
    marqueeScroller: function () {
      if (!customElements.get("marquee-content")) {
        class Marquee extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          calculationPaddingSection() {
            (this.heightSection = this.offsetHeight),
              (this.heightSection =
                this.heightSection < 18
                  ? 18
                  : 96 < this.heightSection
                    ? 96
                    : this.heightSection),
              this.closest(".js-running-content").style.setProperty(
                "--spacing-padding-block",
                this.heightSection + "px"
              );
          }
          init() {
            (this.distance =
              this.querySelector(".js-marquee-item").offsetWidth),
              (this.speed = this.dataset.speed),
              this.style.setProperty(
                "--marquee-duration",
                this.distance / this.speed + "s"
              );
          }
        }
        customElements.define("marquee-content", Marquee);
      }
    },
    slideshowSwiper: function () {

      class slideshowSwiper extends HTMLElement {
        constructor() {
          super();
              this.updSwiperNumericPagination = this.updSwiperNumericPagination.bind(this);
        }

        updSwiperNumericPagination(swiper) {
          // swiper is passed automatically by Swiper
          const counter = this.querySelector(".swiper-counter");
          if (!counter) return;

          counter.innerHTML = `
            <span class="count">${swiper.realIndex + 1}</span> /
            <span class="total">${this.slidesQuantity}</span>
          `;
        }


        connectedCallback() {
          this.sliderWrapper = this.querySelector(".slideshow__swiper");
     
          this.slidesQuantity = this.querySelectorAll(".swiper-slide").length;
          let centered_slides =
            this.sliderWrapper.dataset.centeredslides !== undefined
              ? JSON.parse(this.sliderWrapper.dataset.centeredslides)
              : undefined;
          let effect_fade =
            this.sliderWrapper.dataset.effectfade !== undefined
              ? JSON.parse(this.sliderWrapper.dataset.effectfade)
              : undefined;
          let next = this.querySelector(".swiper-button-next");
          let prev = this.querySelector(".swiper-button-prev");
          let pagination = this.querySelector(".swiper-pagination");
          let scroll = this.querySelector(".swiper-scrollbar");

          new Swiper(this.sliderWrapper, {
            effect: effect_fade ? "fade" : "slide",
            centeredSlides: centered_slides ? centered_slides : false,
            slidesPerView: parseInt(this.sliderWrapper.dataset.slidesmobile),
            spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
            grabCursor: false,
            horizontal: true,
            watchSlidesProgress: true,
            draggable: !0,
            autoHeight: !1,
            watchOverflow: !0,
            threshold: 10,
            freeMode: JSON.parse(this.sliderWrapper.dataset.freemode),
            loop: JSON.parse(this.sliderWrapper.dataset.loop),
            speed: 700,
            mousewheel: {
              forceToAxis: true,
            },
            autoplay: {
              enabled: JSON.parse(this.sliderWrapper.dataset.autoplay),
              disableOnInteraction: false,
              delay: parseInt(this.sliderWrapper.dataset.delay),
            },
            navigation: {
              nextEl: next,
              prevEl: prev,
            },
            pagination: {
              el: pagination,
              clickable: true,
            },
            scrollbar: {
              el: scroll,
              draggable: true,
            },
            breakpoints: {
              359: {
                slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesmobile),
                spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
              },
              768: {
                slidesPerView: parseFloat(this.sliderWrapper.dataset.slidestab),
                spaceBetween: parseInt(this.sliderWrapper.dataset.tabspace),
              },
              1024: {
                slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesdesktop),
                spaceBetween: parseInt(this.sliderWrapper.dataset.desktopspace),
              },
            },
               on: {
            init: this.updSwiperNumericPagination,
            slideChange:  this.updSwiperNumericPagination
          }
          });
        }
      }
      customElements.define("slideshow-swiper", slideshowSwiper);

    },
    autoSlider: function () {
      class AutoSwiper extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.sliderWrapper = this.querySelector(".slideshow__swiper");
          if (!this.sliderWrapper) return;
          const resizeObserver = new ResizeObserver((entries) => this.init());
          resizeObserver.observe(this.sliderWrapper);
          //  console.log("testdd",this.sliderWrapper.dataset)
        }
        init() {
          let centered_slides =
            this.sliderWrapper.dataset.centeredslides !== undefined ? JSON.parse(this.sliderWrapper.dataset.centeredslides) : undefined;
          let effect_fade =
            this.sliderWrapper.dataset.effectfade !== undefined
              ? JSON.parse(this.sliderWrapper.dataset.effectfade)
              : undefined;
          let next = this.querySelector(".swiper-button-next");
          let prev = this.querySelector(".swiper-button-prev");
          let pagination = this.querySelector(".swiper-pagination");

          // console.log("Tress", centered_slides);

          const slider = new Swiper(this.sliderWrapper, {
            effect: effect_fade ? "fade" : "slide",
            centeredSlides: centered_slides ? centered_slides : false,
            slidesPerView: 'auto',
            spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
            grabCursor: true,
            horizontal: true,
            watchSlidesProgress: true,
            draggable: !0,
            autoHeight: !1,
            watchOverflow: !0,
            threshold: 10,
            freeMode: JSON.parse(this.sliderWrapper.dataset.freemode),
            loop: JSON.parse(this.sliderWrapper.dataset.loop),
            speed: 700,
            mousewheel: {
              forceToAxis: true,
            },
            autoplay: {
              enabled: JSON.parse(this.sliderWrapper.dataset.autoplay),
              disableOnInteraction: false,
              delay: parseInt(this.sliderWrapper.dataset.delay)
            },
            navigation: {
              nextEl: next,
              prevEl: prev,
            },
            pagination: {
              el: pagination,
              clickable: true,
            },
            breakpoints: {
              359: {
                spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
              },
              768: {
                spaceBetween: parseInt(this.sliderWrapper.dataset.tabspace),
              },
              1024: {
                spaceBetween: parseInt(this.sliderWrapper.dataset.desktopspace),
              },
            },
          });

          return slider;
        }
      }
      customElements.define("auto-swiper", AutoSwiper);
    },

    videLoad: function () {
      class THMLazyLoadingVideo extends HTMLElement {
        constructor() {
          super(),
            (this.iframe = this.querySelector("iframe")),
            (this.template = this.querySelector("template")),
            (this.isMouseenter = !1);
        }
        loadVideo() {
          var t;
          this.iframe &&
            (this.iframe.setAttribute("src", this.iframe.getAttribute("data-src")),
              this.iframe.addEventListener(
                "load",
                function () {
                  "youtube" == this.dataVideoType &&
                    this.iframe.contentWindow.postMessage(
                      '{"event":"command","func":"playVideo","args":""}',
                      "*"
                    ),
                    "vimeo" == this.dataVideoType &&
                    this.iframe.contentWindow.postMessage('{"method":"play"}', "*");
                }.bind(this)
              )),
            "local_video" == this.dataVideoType &&
            ((this.local_video = this.querySelector("video")),
              (t = this.local_video.querySelector("source").getAttribute("data-src")),
              (this.local_video.src = t));
        }
        execute() {
          Shopify.designMode
            ? this.loadVideo()
            : (["mousemove", "touchstart"].forEach(
              function (t) {
                THMHelper.qs("body").addEventListener(
                  t,
                  function (t) {
                    this.isMouseenter || this.loadVideo(), (this.isMouseenter = !0);
                  }.bind(this),
                  { once: !0 }
                );
              }.bind(this)
            ),
              window.addEventListener(
                "scroll",
                function (t) {
                  this.isMouseenter || this.loadVideo(), (this.isMouseenter = !0);
                }.bind(this),
                { once: !0 }
              ));
        }
        static get observedAttributes() {
          return ["data-video-type", "data-video-id"];
        }
        set dataVideoType(t) {
          this.setAttribute("data-video-type", t);
        }
        get dataVideoType() {
          return this.getAttribute("data-video-type");
        }
        set dataVideoId(t) {
          this.setAttribute("data-video-id", t);
        }
        get dataVideoId() {
          return this.getAttribute("data-video-id");
        }
        attributeChangedCallback(t, e, s) {
          e !== s && this.execute();
        }
        connectedCallback() {
          this.execute();
        }
        disconnectedCallback() { }
      }
      customElements.define("thm-load-video", THMLazyLoadingVideo);

      class THMLoadMedia extends HTMLElement {
        constructor() {
          super(),
            (this.$ = this.querySelector.bind(this)),
            (this.sectionID = this.dataset.sectionId),
            (this.idVideo = this.dataset.idVideo),
            (this.typeVideo = this.dataset.type),
            (this.eleVideo = `shtVideo-${this.sectionID}-` + this.idVideo),
            (this.onPlayerStateYTChange = this.onPlayerStateYTChange.bind(this)),
            (this.onPlayerPlay = this.onPlayerPlay.bind(this)),
            (this.playPauseButton = this.$(".video-play-pause-button")),
            (this.trigger = this.$(".js-load-media-trigger")),
            this.trigger && this.trigger.addEventListener("click", this.handlePlayVideo.bind(this));

          if (this.playPauseButton) {
            this.playPauseButton.addEventListener("click", this.togglePlayPauseVideo.bind(this));
          }
        }


        togglePlayPauseVideo() {
        this.classList.add("playing");
        this.loadContent();

        const video = this.$(".js-media-item-video");

        if (!video) return;

        // First time play: pause others, play this
        if (video.paused || video.ended) {
          this.pauseAllVideo(video);
          video.play();
          this.updatePlayPauseIcon(true);
        } else {
          video.pause();
          this.updatePlayPauseIcon(false);
        }

        // ✅ If YouTube player is present
        if (this.player && typeof this.player.getPlayerState === "function") {
          const state = this.player.getPlayerState();
          if (state === YT.PlayerState.PAUSED || state === YT.PlayerState.ENDED) {
            this.pauseAllVideo(this.player);
            this.player.playVideo();
            this.updatePlayPauseIcon(true);
          } else if (state === YT.PlayerState.PLAYING) {
            this.player.pauseVideo();
            this.updatePlayPauseIcon(false);
          }
        }



      }

        updatePlayPauseIcon(isPlaying) {
          const playIcon = this.playPauseButton?.querySelector(".video-play-icon");
          const pauseIcon = this.playPauseButton?.querySelector(".video-pause-icon");

          if (!playIcon || !pauseIcon) return;

          if (isPlaying) {
            playIcon.style.display = "none";
            pauseIcon.style.display = "inline";
          } else {
            playIcon.style.display = "inline";
            pauseIcon.style.display = "none";
          }
        }


        
        handlePlayVideo() {
          this.classList.add("playing");
          this.loadContent();
          const t = this.querySelector(".js-media-item-video");
          t &&
            t.addEventListener("play", () => {
              this.pauseAllVideo(t), t.play();
            });
        }
        onYouTubeIframeAPIReady() {
          if ("undefined" != typeof YT && void 0 !== YT.Player)
            try {
              this.player = new YT.Player(this.eleVideo, {
                videoId: this.idVideo,
                playerVars: { playsinline: 1 },
                events: {
                  onReady: this.onPlayerYTReady,
                  onStateChange: this.onPlayerStateYTChange,
                },
              });
            } catch (t) {
              console.error("Lỗi khi tạo trình phát YouTube:", t);
            }
          else {
            var t = document.createElement("script"),
              e =
                ((t.src = "https://www.youtube.com/iframe_api"),
                  (t.onload = () => {
                    this.onYouTubeIframeAPIReady();
                  }),
                  document.getElementsByTagName("script")[0]);
            e.parentNode.insertBefore(t, e);
          }
        }
        onVimeoIframeAPIReady() {
          if ("undefined" != typeof Vimeo && void 0 !== Vimeo.Player)
            try {
              var t = { id: this.idVideo, autoplay: 1 };
              (this.playerVimeo = new Vimeo.Player(this.eleVideo, t)),
                this.playerVimeo.on("play", () => {
                  this.pauseAllVideo(this.playerVimeo);
                });
            } catch (t) {
              console.error("Lỗi khi tạo trình phát Vimeo:", t);
            }
          else {
            var t = document.createElement("script"),
              e =
                ((t.src = "https://player.vimeo.com/api/player.js"),
                  (t.onload = () => {
                    this.onVimeoIframeAPIReady();
                  }),
                  document.getElementsByTagName("script")[0]);
            e.parentNode.insertBefore(t, e);
          }
        }
        onPlayerYTReady = () => {
          this.pauseAllVideo(this.player), this.player.playVideo();
        };
        // onPlayerStateYTChange = (t) => {
        //   1 == t.data && this.onPlayerPlay();
        // };

          onPlayerStateYTChange = (t) => {
            const state = t.data;

            if (state === YT.PlayerState.PLAYING) {
              this.onPlayerPlay(); // pause other videos
              this.updatePlayPauseIcon(true); // 👈 show pause icon
            } else if (
              state === YT.PlayerState.PAUSED ||
              state === YT.PlayerState.ENDED
            ) {
              this.updatePlayPauseIcon(false); // 👈 show play icon
            }
          };



        onPlayerPlay = () => {
          this.pauseAllVideo(this.player);
        };
        loadContent() {
          if (!this.getAttribute("loaded")) {
            if (this.$("template")) {
              var t = this.$("template").content.firstElementChild.cloneNode(!0);
              this.appendChild(t),
                this.isLoaded(!0),
                this.trigger && this.trigger.remove();

                // 🔽 ADD HERE AFTER APPENDING VIDEO
                const video = this.$(".js-media-item-video");
                if (video && !video.hasAttribute("data-listeners-added")) {
                  video.addEventListener("play", () => this.updatePlayPauseIcon(true));
                  video.addEventListener("pause", () => this.updatePlayPauseIcon(false));
                  video.addEventListener("ended", () => this.updatePlayPauseIcon(false));
                  video.setAttribute("data-listeners-added", "true");
                }

            } else {
              if ("youtube" == this.typeVideo) this.onYouTubeIframeAPIReady();
              else {
                if ("vimeo" != this.typeVideo) return !0;
                this.onVimeoIframeAPIReady();
              }
                this.trigger?.classList.add("d-none"),
                this.$(".js-media-item").classList.add("d-flex");

                // 🔽 ALSO ADD HERE in case video is not loaded via <template>
                  const video = this.$(".js-media-item-video");
                  if (video && !video.hasAttribute("data-listeners-added")) {
                    video.addEventListener("play", () => this.updatePlayPauseIcon(true));
                    video.addEventListener("pause", () => this.updatePlayPauseIcon(false));
                    video.addEventListener("ended", () => this.updatePlayPauseIcon(false));
                    video.setAttribute("data-listeners-added", "true");
                  }

            }
            return !0;
          }
        }
        pauseAllVideo(e) {
          THMHelper.qsa(
            ".js-product-media-deferred-video:has([data-type='youtube']"
          ).forEach((t) => {
            t.player && e !== t.player && t.player?.pauseVideo();
          }),
            THMHelper.qsa(
              ".js-product-media-deferred-video:has([data-type='vimeo'])"
            ).forEach((t) => {
              t.playerVimeo !== e && t.playerVimeo?.pause();
            }),
            THMHelper.qsa(".js-media-item-video").forEach((t) => {
              t !== e && t.pause();
            });
        }
        isLoaded(t) {
          t ? this.setAttribute("loaded", !0) : this.removeAttribute("loaded");
        }
      }
      customElements.define("thm-load-media", THMLoadMedia);
    },
   collapsibleContent: function () {

   if (!customElements.get("collapsible-content")) {
        class collapsibleContent extends HTMLElement {
          constructor() {
            super();
            this.disclosure = this.querySelector('details');
            this.toggle = this.querySelector('summary');
            this.panel = this.toggle.nextElementSibling;
            this.init();
          }

          init() {
            // Check if the content element has a CSS transition.
            if (window.getComputedStyle(this.panel).transitionDuration !== '0s') {
              this.toggle.addEventListener('click', this.handleToggle.bind(this));
              this.disclosure.addEventListener('transitionend', this.handleTransitionEnd.bind(this));
            }
          }

          /**
           * Handles 'click' events on the summary element.
           * @param {object} evt - Event object.
           */
          handleToggle(evt) {
            evt.preventDefault();

            if (!this.disclosure.open) {
              this.open();
            } else {
              this.close();
            }
          }

          /**
           * Handles 'transitionend' events on the details element.
           * @param {object} evt - Event object.
           */
          handleTransitionEnd(evt) {
            if (evt.target !== this.panel) return;

            if (this.disclosure.classList.contains('is-closing')) {
              this.disclosure.classList.remove('is-closing');
              this.disclosure.open = false;
            }

            this.panel.removeAttribute('style');
          }

          /**
           * Adds inline 'height' style to the content element, to trigger open transition.
           */
          addContentHeight() {
            this.panel.style.height = `${this.panel.scrollHeight}px`;
          }

          /**
           * Opens the details element.
           */
          open() {
            // Set content 'height' to zero before opening the details element.
            this.panel.style.height = '0';

            // Open the details element
            this.disclosure.open = true;

            // Set content 'height' to its scroll height, to enable CSS transition.
            this.addContentHeight();
          }

          /**
           * Closes the details element.
           */
          close() {
            // Set content height to its scroll height, to enable transition to zero.
            this.addContentHeight();

            // Add class to enable styling of content or toggle icon before or during close transition.
            this.disclosure.classList.add('is-closing');

            // Set content height to zero to trigger the transition.
            // Slight delay required to allow scroll height to be applied before changing to '0'.
            setTimeout(() => {
              this.panel.style.height = '0';
            });
          }
        }
        customElements.define('collapsible-content', collapsibleContent);
      }
    
    },

    stickyProduct:function(){
      function TopOffset(el) {
    let rect = el.getBoundingClientRect(),
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop };
}

customElements.define("sticky-component", Stickybar);
    }
  },
};


document.addEventListener('DOMContentLoaded', function () {
  Thm.init();
});



  class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.interval = null;
  }

  connectedCallback() {
    this.render();
    this.startTimer();
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  parseEndTimeUTCMinus4(str) {
    const date = new Date(str); // parse as local time
    const localOffset = date.getTimezoneOffset(); // minutes
    const targetOffset = 4 * 60; // 240 minutes for UTC-4
    return date.getTime() + (localOffset + targetOffset) * 60 * 1000;
  }

  startTimer() {
    const endTimeAttr = this.getAttribute('data-endtime');
    if (!endTimeAttr) return;

    const endTime = this.parseEndTimeUTCMinus4(endTimeAttr);

    this.interval = setInterval(() => {
      const now = Date.now();
      let timeLeft = Math.floor((endTime - now) / 1000);

      if (timeLeft <= 0) {
        clearInterval(this.interval);
        this.innerHTML = `<span class="expired">00<span>DAYS</span></span>
                          <span class="expired">00<span>HOURS</span></span>
                          <span class="expired">00<span>MINUTES</span></span>
                          <span class="expired">00<span>SECONDS</span></span>`;
        return;
      }

      const days = String(Math.floor(timeLeft / 86400)).padStart(2, '0');
      timeLeft %= 86400;
      const hours = String(Math.floor(timeLeft / 3600)).padStart(2, '0');
      timeLeft %= 3600;
      const minutes = String(Math.floor(timeLeft / 60)).padStart(2, '0');
      const seconds = String(timeLeft % 60).padStart(2, '0');

      this.innerHTML = `
        <span id="days">${days}<span class="count-text">DAYS</span></span>
        <span id="hours">${hours}<span class="count-text">HOURS</span></span>
        <span id="minutes">${minutes}<span class="count-text">MINUTES</span></span>
        <span id="seconds">${seconds}<span class="count-text">SECONDS</span></span>
      `;
    }, 1000);
  }

  render() {
    this.style.display = 'inline-flex';
    this.innerHTML = `Loading...`;
  }
}

customElements.define('countdown-timer', CountdownTimer);





const cards = document.querySelectorAll('.expandable-card');
cards.forEach(card => {
  card.addEventListener('click', () => {
    cards.forEach(c => c.classList.remove('active'));
    card.classList.add('active');
  });
});





class thumnailSwiper extends HTMLElement {
  constructor() {
    super();
    this.updSwiperNumericPagination = this.updSwiperNumericPagination.bind(this);
  }

     updSwiperNumericPagination(swiper) {
          // swiper is passed automatically by Swiper
          const counter = this.querySelector(".swiper-counter");
          if (!counter) return;

          counter.innerHTML = `
            <span class="count">${swiper.realIndex + 1}</span> /
            <span class="total">${this.slidesQuantity}</span>
          `;
        }


  connectedCallback() {
    this.main_slider = this.querySelector(".main-slider");
    this.thumbnails = this.querySelector(".thmanails-slider");
        this.slidesQuantity =  this.main_slider.querySelectorAll(".swiper-slide").length;
        


    if (!this.main_slider) return;
    const resizeObserver = new ResizeObserver((entries) => this.init());
    resizeObserver.observe(this.main_slider);
  }
  init() {
    var thumbnails = new Swiper(this.thumbnails, {
      slidesPerView: 2.55,
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      spaceBetween: 20,
    });
    let next = this.querySelector(".swiper-button-next");
    let prev = this.querySelector(".swiper-button-prev");
    let pagination = this.querySelector(".swiper-pagination");

    var slider = new Swiper(this.main_slider, {
      loop: JSON.parse(this.main_slider.dataset.loop),
      autoplay: {
        enabled: JSON.parse(this.main_slider.dataset.autoplay),
        disableOnInteraction: false,
        delay: parseInt(this.main_slider.dataset.delay),
      },
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      pagination: {
        el: pagination,
        clickable: true,
      },
     on: {
            init: this.updSwiperNumericPagination,
            slideChange:  this.updSwiperNumericPagination
          },
      thumbs: {
        swiper: thumbnails,
      },
    });
  }
}
customElements.define("thumbnails-slider", thumnailSwiper);




class GridSwiper extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
  }

  connectedCallback() {
    this.grid__swiper = this.querySelector(".grid__swiper");
    if (!this.grid__swiper) return;

    this.resizeObserver = new ResizeObserver(() => this.checkAndInit());
    this.resizeObserver.observe(this.grid__swiper);

    this.checkAndInit(); // run once on load
  }

  disconnectedCallback() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    this.destroySwiper();
  }

  checkAndInit() {
    const isMobile = window.innerWidth < 768; // breakpoint threshold

    if (isMobile && !this.swiperInstance) {
      this.init();
    } else if (!isMobile && this.swiperInstance) {
      this.destroySwiper();
    }
  }

  init() {
    let centered_slides =
      this.grid__swiper.dataset.centeredslides !== undefined
        ? JSON.parse(this.grid__swiper.dataset.centeredslides)
        : undefined;
    let effect_fade =
      this.grid__swiper.dataset.effectfade !== undefined
        ? JSON.parse(this.grid__swiper.dataset.effectfade)
        : undefined;
    let Gnext = this.querySelector(".swiper-button-next");
    let Gprev = this.querySelector(".swiper-button-prev");
    let pagination = this.querySelector(".swiper-pagination");

    this.swiperInstance = new Swiper(this.grid__swiper, {
      effect: effect_fade ? "fade" : "slide",
      centeredSlides: centered_slides ? centered_slides : false,
      slidesPerView: parseInt(this.grid__swiper.dataset.slidesmobile),
      spaceBetween: parseInt(this.grid__swiper.dataset.mobilespace),
      grabCursor: false,
      horizontal: true,
      watchSlidesProgress: true,
      draggable: true,
      autoHeight: false,
      watchOverflow: true,
      threshold: 10,
      freeMode: true,
      loop: JSON.parse(this.grid__swiper.dataset.loop),
      speed: 1000,
      grid: {
        rows: 2,
      },
      mousewheel: {
        forceToAxis: true,
      },
      autoplay: {
        enabled: JSON.parse(this.grid__swiper.dataset.autoplay),
        disableOnInteraction: false,
        delay: parseInt(this.grid__swiper.dataset.delay),
      },
      navigation: {
        nextEl: Gnext,
        prevEl: Gprev,
      },
      pagination: {
        el: pagination,
        clickable: true,
      },
    });
  }

  destroySwiper() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }
}

customElements.define("grid-slider", GridSwiper);




if (!customElements.get('tabbed-content')) {
    class Tabs extends HTMLElement {
        constructor() {
            super();
            this.tabList = this.querySelector('[role="tablist"]');
            this.activeTab = this.tabList.querySelector('[aria-selected="true"]');
            this.isVerticalTablist = this.tabList.getAttribute('aria-orientation') === 'vertical';
            this.tabs = this.querySelectorAll('[role="tab"]');
            this.panels = this.querySelectorAll('[role="tabpanel"]');

            // If no tab is active by default, activate the first tab.
            if (!this.activeTab) {
                this.activeTab = this.tabs[0];
                this.activateTab(this.activeTab);
            }

            this.addListeners();
        }

        addListeners() {
            this.tabList.addEventListener('click', this.handleClick.bind(this));
            this.tabList.addEventListener('keydown', this.handleKeydown.bind(this));
        }

        handleClick(evt) {
            if (!evt.target.matches('[role="tab"]') || evt.target === this.activeTab) return;
            this.activateTab(evt.target);

        }

        handleKeydown(evt) {
            switch (evt.key) {
                case 'ArrowLeft':
                case 'ArrowRight':
                    evt.preventDefault();
                    if (!this.isVerticalTablist) {
                        this.switchTabOnKeyPress(evt.key);
                    }
                    break;

                case 'ArrowUp':
                case 'ArrowDown':
                    evt.preventDefault();
                    if (this.isVerticalTablist) {
                        this.switchTabOnKeyPress(evt.key);
                    }
                    break;

                case 'Home':
                    evt.preventDefault();
                    this.activateTab(this.tabs[0]);
                    break;

                case 'End':
                    evt.preventDefault();
                    this.activateTab(this.tabs[this.tabs.length - 1]);
                    break;
            }
        }

        switchTabOnKeyPress(key) {
            if (key === 'ArrowRight' || key === 'ArrowDown') {
                if (this.activeTab === this.tabs[this.tabs.length - 1]) {
                    this.activateTab(this.tabs[0]);
                } else {
                    this.activateTab(this.activeTab.nextElementSibling);
                }
            } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
                if (this.activeTab === this.tabs[0]) {
                    this.activateTab(this.tabs[this.tabs.length - 1]);
                } else {
                    this.activateTab(this.activeTab.previousElementSibling);
                }
            }
        }

        activateTab(tab) {
            this.deactivateActiveTab();

            Tabs.setTabState(tab, true);
            tab.removeAttribute('tabindex');
            this.activeTab = tab;

            const panelId = tab.getAttribute('aria-controls');
            const panel = document.getElementById(panelId);

            if (panel) {
                panel.classList.add('fade-in');  // Add animation class

                setTimeout(() => {
                    panel.classList.remove('fade-in');
                }, 500);
            }

            if (document.activeElement.matches('.tablist__tab')) {
                tab.focus();
            }
        }

        deactivateActiveTab() {
            Tabs.setTabState(this.activeTab, false);
            this.activeTab.setAttribute('tabindex', '-1');
            this.activeTab = null;
        }

        static setTabState(tab, active) {
            tab.setAttribute('aria-selected', active);

            const panelId = tab.getAttribute('aria-controls');
            const panel = document.getElementById(panelId);

            if (panel) {
                if (active) {
                    panel.hidden = false;
                } else {
                    panel.hidden = true;
                }
            }
        }

    }

    customElements.define('tabbed-content', Tabs);
}